import React, { useState, useEffect } from 'react'
import Button from '../../components/button'
import meteorBlue from '../../assets/images/meteor-blue.svg'

const GameCard = ({ title, to }) => {
  return (
    <div className='game-card animated w-25 text-center'>
      <img src={meteorBlue} width='48' height='48' alt='meteor' />
      <h1 className='title'>{title}</h1>
      {to ? (
        <Button to={to}>PLAY</Button>
      ) : (
        <div className='text-bg'>Under Construction</div>
      )}
    </div>
  )
}

const Dashboard = () => {
  const [step, setStep] = useState(0)

  useEffect(() => {
    const timer = setTimeout(() => {
      if (step < 3) setStep(step + 1)
    }, 200)

    return () => {
      clearTimeout(timer)
    }
  })

  return (
    <div className='d-flex dashboard justify-content-center align-items-center h-100'>
      {step >= 1 && <GameCard title='Basic 4' to='/basic4' />}
      {step >= 2 && <GameCard title='MasterMind' to='/mastermind' />}
      {step >= 3 && <GameCard title='24k Game' to='/24-game' />}
    </div>
  )
}

export default Dashboard
